import { Button, Progress, dialog } from "nq-component";
import CardView from "../../../../components/common/CardView";
import BaseListPage from "../../../../base/BaseListPage";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import Presenter from "../../../HumanResource/Employees/forms/DropdownTable/Presenter";
import UserModal from "./UserModal";
import { FloatingForm } from "../../../../components/common/Converter";

export default class BiometricFinger extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new Presenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = { activeButton: "" };
  }

  componentDidMount() {
    this.presenter.componentDidMount();
    document.body.classList.add("modal-open");
  }

  componentWillUnmount() {
    document.body.classList.remove("modal-open");
  }

  getCollectionName() {
    return "devices";
  }

  dialogClose() {
    dialog.close();
  }
  confirmChanges() {
    const data = {
      ...this.props.bioData,
      finger: this.state.activeButton.toString(),
    };
    alert(JSON.stringify(data));
    console.log();
    this.dialogClose();
    this.props.closeModal();
    this.showSuccess("Success");
    this.props.refetchData();
  }

  handleClickOk() {
    dialog.fire({
      html: (
        <div className="row p-2">
          <div className="row">
            <h4>Confirmation</h4>
            <hr />
            <p style={{ fontSize: "13px", padding: "1rem" }}>
              Are you sure you want to process this Biometrics?
            </p>
            <hr />
          </div>

          <div className="w-100 d-flex justify-content-end gap-4 pe-3 pb-3">
            <Button
              className="btn btn-light fs-sm"
              onClick={this.dialogClose.bind(this)}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              onClick={this.confirmChanges.bind(this)}
            >
              Confirm
            </Button>
          </div>
        </div>
      ),
      footer: false,
    });
  }

  closeSelectModal() {
    this.setState({ selectModal: false });
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  setActiveButton(index) {
    console.log("INDEX: ", index);
    this.setState({ activeButton: index });
  }
  render() {
    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <Progress />;

    return (
      <>
        <>
          <FloatingForm width="60rem">
            <CardView style={{ padding: 0 }}>
              <h4 className="fs-6 fw-bold pt-3 ps-3">
                Assign Biometric Finger
              </h4>
              <hr />
              <div className="w-100 pt-3" style={{ padding: "0 1.5rem" }}>
                <h4 className="d-flex align-items-center pb-4">
                  <span
                    className="d-flex justify-content-center align-items-center me-2 rounded text-white"
                    style={{
                      width: "3rem",
                      height: "3rem",
                      fontSize: "1.5rem",
                      backgroundColor: "#ccc",
                    }}
                  >
                    {this.props.bioData.username.substring(0, 2).toUpperCase()}
                  </span>
                  <strong>{this.props.bioData.username}</strong>
                </h4>

                <div className=" d-flex justify-content-center align-items-center gap-3">
                  <div className=" d-grid gap-3">
                    {[
                      "0 Left Pinky",
                      "1 Left Ring Finger",
                      "2 Left Middle Finger",
                      "3 Left Index Finger",
                      "4 Left Thumb",
                    ].map((label, index) => (
                      <Button
                        key={index}
                        onClick={() => this.setActiveButton(index)}
                        style={{
                          backgroundColor:
                            this.state.activeButton !== index && "transparent",
                          color:
                            this.state.activeButton === index
                              ? "white"
                              : "black",
                        }}
                      >
                        {label}
                      </Button>
                    ))}
                  </div>
                  <img
                    src={"/fingerPrint.png"}
                    style={{ filter: "invert(1)" }}
                    height="450"
                    width="500"
                    alt="Fingerprint"
                  />
                  <div className=" d-grid gap-3">
                    {[
                      "5 Right Thumb",
                      "6 Right Index Finger",
                      "7 Right Middle Finger",
                      "8 Right Ring Finger",
                      "9 Right Pinky",
                    ].map((label, index) => (
                      <Button
                        key={index}
                        onClick={() => this.setActiveButton(index + 5)}
                        style={{
                          backgroundColor:
                            this.state.activeButton !== index + 5 &&
                            "transparent",
                          color:
                            this.state.activeButton === index + 5
                              ? "white"
                              : "black",
                        }}
                      >
                        {label}
                      </Button>
                    ))}
                  </div>
                </div>
              </div>
              <hr />
              <div className="w-100 d-flex justify-content-end gap-4 mb-3 pe-3">
                <Button
                  className="btn btn-light fs-sm"
                  onClick={() => this.props.closeModal()}
                >
                  Cancel
                </Button>
                <Button
                  className="btn btn-primary"
                  onClick={this.handleClickOk.bind(this)}
                >
                  OK
                </Button>
              </div>
            </CardView>
          </FloatingForm>

          {this.state.selectModal && (
            <UserModal closeSelectModal={this.closeSelectModal.bind(this)} />
          )}
        </>
      </>
    );
  }
}
